import React from "react";
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  withRouter,
} from "react-router-dom";
import { PopupsProvider } from "../helpers/contexts/popupsContext";

import Home from "../components/home/index";
import Header from "../components/MainNavigation";
import SubHeader from "../components/subheader/index";
import { connect } from "react-redux";
import "./styles/index.scss";
import Actions from "../actions";
import LinkExpiredPopup from "../components/popup/linkExpiredPopup";
import ChangePasswordPopup from "../components/popup/changePasswordPopup";

import AppContainerDnD from "../helpers/contexts/dragDropContext";

import { clickToLinkHandler } from "../helpers/utils";
import {
  getUserId,
  getUserRole,
  isSessionExpired,
} from "../reducers/selectors";
import SessionExpiredPopup from "../components/popup/sessionExpiredPopup";
import Helpers from "../components/notifications/helpers";
import { isEmpty } from "../helpers/utilsTS";

const Routes = (props) => {
  const {
    confirm,
    getUser,
    userId,
    userRole,
    accessError,
    isSessionExpired,
    user,
  } = props;

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const redirect = params.get("redirect");
  const code = params.get("code");

  if (userId !== -1) {
    getUser(userId);
  } else if (code) {
    confirm(code);
  }

  if (redirect && isEmpty(code)) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className={userRole ? "user-container" : "guest-container"}>
      <AppContainerDnD>
        <PopupsProvider>
          {userRole && <Route path="/" component={Header} />}
          <Switch>
            <Route path={`/:orgId/deals`} component={SubHeader} />
            <Route path={`/:userId`} component={SubHeader} />
          </Switch>
          <Route path="/" component={Home} />
          <LinkExpiredPopup isOpen={!!accessError} code={code} />
          {userRole && (
            <ChangePasswordPopup
              redirect={redirect}
              isOpen={!user.last_activity}
              canDismiss={false}
            />
          )}
          {userRole && <Helpers />}
          <SessionExpiredPopup
            isOpen={isSessionExpired}
            onClose={() => {
              clickToLinkHandler("/");
              window.location.reload();
            }}
          />
        </PopupsProvider>
      </AppContainerDnD>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { accessError } = state.auth;
  const { user } = state.auth;

  return {
    user: user,
    userId: getUserId(state),
    userRole: getUserRole(state),
    isSessionExpired: isSessionExpired(state),
    accessError,
  };
};

const mapDispatchToProps = (dispatch) => ({
  confirm: function (data) {
    dispatch(Actions.confirm(data));
  },
  getUser: function (userId) {
    dispatch(Actions.getUser(userId));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Routes));
